module.exports = __webpack_public_path__ + "img/group-s2.28a00904.png";